import _ from "lodash";
import client from "lib/apolloClient/client";
import { createNewThirdPartyDocumentMutation } from "./CreateDriveDocumentMutations";

export const createNewThirdPartyDocument = ({
  name,
  serviceType,
  type,
  documentType,
  academicYearId,
  curriculumProgramId,
  learningCourseId,
  classId,
  submissionId,
}) => {
  return async () => {
    try {
      const response = await client.mutate({
        mutation: createNewThirdPartyDocumentMutation,
        variables: {
          name,
          serviceType,
          ...(!_.isEmpty(type) ? { type } : {}),
          documentType,
          academicYearId,
          curriculumProgramId,
          learningCourseId,
          classId,
          submissionId,
        },
      });

      return _.get(response, "data.platform.createNewThirdPartyDocument", {});
    } catch (error) {
      return {
        isSuccess: false,
        warning: error.message,
      };
    }
  };
};
